module.exports = __webpack_public_path__ + "76b44e78dcc20623435352ce634b3848.png";